import MainBlock from "@blocks/Container/MainBlock";
import WrapperBlock from "@blocks/Container/WrapperBlock";
import { AdsImu2 } from "@elements/Advertisement/variant/AdsImu";
import Divider from "@elements/Divider/Divider";
import { ReactElement } from "react";

import { KeywordArticlesCards } from "./KeywordArticleCards";
import { KeywordVariantProps } from "./KeywordVariantHelper";

export default function Deepavali({
  tagAlias = "deepavali",
  tagName = "தீபாவளி",
  sectionName,
  keywordArticles,
  showBreadcrumbs = true,
  showTitle = true,
  pageAdTargetValue,
  recordedVideo,
}: KeywordVariantProps): ReactElement {
  return (
    <WrapperBlock className="flex flex-col lg:flex-row justify-between">
      <>
        <MainBlock
          sectionName={tagName}
          showBreadcrumbs={showBreadcrumbs}
          showTitle={showTitle}
          className="lg:!pr-0 lg:border-0"
        >
          {recordedVideo && (
            <div className="mb-5">
              <div dangerouslySetInnerHTML={{ __html: recordedVideo }} />
            </div>
          )}
          <KeywordArticlesCards
            tagAlias={tagAlias}
            sectionName={sectionName}
            keywordArticles={keywordArticles}
            pageAdTargetValue={pageAdTargetValue}
            placement={"main"}
          />
        </MainBlock>
        <div className="lg:w-4/12 lg:pr-xxs lg:pl-md min-h-[800px]">
          <div data-testid="side-block" className="w-full">
            <AdsImu2
              sectionName={sectionName}
              pageAdTargetType={pageAdTargetValue}
            />
            <Divider className="border-b border-gray-2200" />
          </div>
        </div>
      </>
    </WrapperBlock>
  );
}
